import FormControlLabel from '@mui/material/FormControlLabel';
import { TextField } from '@mui/material';
import { IOSSwitch } from '../common/IosSwitch';
import Collapse from '@mui/material/Collapse';
import { useState } from 'react';
import { selectLienHolderInfo } from '../../redux-state/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { UPDATE_LIEN_HOLDER_INFO } from '../../redux-state/forms/types';

function LienHolderInformation() {
  const [isFieldVisible, setIsFieldVisible] = useState(true);
  const lienHolderInfo = useSelector(selectLienHolderInfo);
  const dispatch = useDispatch();


  const handleChange = (key, value) => {
    dispatch({
      type: UPDATE_LIEN_HOLDER_INFO,
      payload: { key, value },
    });
  };

  return (
    <div className="flex flex-col">
      <div className={`flex flex-row justify-between p-4 ${isFieldVisible ? 'rounded-t-xl' : 'rounded-xl'} bg-white text-gray-700`}>
        <div className="text-md font-bold">Lienholder Information</div>
        <div className="flex flex-row">
          <div className="mt-1">{isFieldVisible ? 'Show Detail' : 'Hide Detail'}</div>
          <div>
            <FormControlLabel
              control={<IOSSwitch sx={{ ml: 3 }} checked={isFieldVisible} onChange={(e) => setIsFieldVisible(e.target.checked)} />}
            />
          </div>
        </div>
      </div>

      <Collapse in={isFieldVisible} timeout={500} unmountOnExit>
        <div className="flex flex-col bg-white p-4 gap-4 rounded-b-xl text-gray-900">
          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              name="lienholderCompanyName"
              label="Lienholder Company Name"
              variant="outlined"
              className="flex-1"
              value={lienHolderInfo?.lienholderCompanyName || ''}
              onChange={(e) => handleChange('lienholderCompanyName', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
            <TextField
              name="lienholderAddress"
              label="Lienholder Address"
              variant="outlined"
              className="flex-1"
              value={lienHolderInfo?.lienholderAddress || ''}
              onChange={(e) => handleChange('lienholderAddress', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              name="lienholderAddress2"
              label="Lienholder Address 2"
              variant="outlined"
              className="flex-1"
              value={lienHolderInfo?.lienholderAddress2 || ''}
              onChange={(e) => handleChange('lienholderAddress2', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
            <TextField
              name="lienholderCity"
              label="Lienholder City"
              variant="outlined"
              className="flex-1"
              value={lienHolderInfo?.lienholderCity || ''}
              onChange={(e) => handleChange('lienholderCity', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              name="lienholderState"
              label="Lienholder State"
              variant="outlined"
              className="flex-1"
              value={lienHolderInfo?.lienholderState || ''}
              onChange={(e) => handleChange('lienholderState', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
            <TextField
              name="lienholderZip"
              label="Lienholder ZIP Code"
              variant="outlined"
              className="flex-1"
              value={lienHolderInfo?.lienholderZip || ''}
              onChange={(e) => handleChange('lienholderZip', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              name="lienholderFederalTaxId"
              label="Lienholder Federal Tax ID"
              variant="outlined"
              className="flex-1"
              value={lienHolderInfo?.lienholderFederalTaxId || ''}
              onChange={(e) => handleChange('lienholderFederalTaxId', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
            <TextField
              name="lienholderStateTaxId"
              label="Lienholder State Tax ID"
              variant="outlined"
              className="flex-1"
              value={lienHolderInfo?.lienholderStateTaxId || ''}
              onChange={(e) => handleChange('lienholderStateTaxId', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              name="lienholderEltName"
              label="Lienholder ELT Name"
              variant="outlined"
              className="flex-1"
              value={lienHolderInfo?.lienholderEltName || ''}
              onChange={(e) => handleChange('lienholderEltName', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
            <TextField
              name="lienholderEltId"
              label="Lienholder ELT ID"
              variant="outlined"
              className="flex-1"
              value={lienHolderInfo?.lienholderEltId || ''}
              onChange={(e) => handleChange('lienholderEltId', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              name="lienholderEltAddress"
              label="Lienholder ELT Address"
              variant="outlined"
              className="flex-1"
              value={lienHolderInfo?.lienholderEltAddress || ''}
              onChange={(e) => handleChange('lienholderEltAddress', e.target.value)}
              InputProps={{ style: { borderRadius: '10px' } }}
            />
          </div>
        </div>
      </Collapse>
    </div>
  );
}

export default LienHolderInformation;
